import React from 'react'

import ReactDOM from 'react-dom'

import '@sponte/lib-utils/dist/yup-validations'

import App from 'App'

import Providers from 'providers'

ReactDOM.render(
  <Providers>
    <App />
  </Providers>,
  document.getElementById('root')
)
